import { ArrowRight } from "lucide-react";
import styles from "./TextLink.module.css";

// Underlined text action with an optional trailing arrow ("View all →", "Review →")
export default function TextLink({ children, arrow = true, className = "", ...props }) {
  return (
    <button type="button" className={`${styles.link} ${className}`} {...props}>
      <span className={styles.text}>{children}</span>
      {arrow ? <ArrowRight size={16} strokeWidth={1.75} aria-hidden="true" /> : null}
    </button>
  );
}
